import { TipoLotacao } from "@/modules/business/lotacoes/enums/tipo-lotacao.enum";
import { TipoPeriodoDescanso } from "@/modules/business/periodo/enums/tipo-periodo-descanso.enum";
import { ModuloSistema } from "./modulos-sistema.enum";

export class IEnumObject {
  name!: string;
  value!: number | string;
  checked?: boolean;
}

export class EnumUtils {
  public static generateEnumObjects(enumType: any): IEnumObject[] {
    return Object.keys(enumType)
      .filter((key) => isNaN(Number(key))) // Filtra apenas os nomes, ignorando os valores numéricos
      .map((key) => ({
        name: key,
        value: enumType[key],
        checked: false,
      }))
      .map((obj) => ({ ...obj }));
  }
}

export const TipoLotacaoList: IEnumObject[] = [
  { name: 'Substituição', value: TipoLotacao.Substituicao },
  { name: 'Acumulação', value: TipoLotacao.Acumulacao },
  { name: 'Titularidade', value: TipoLotacao.Titularidade },
  { name: 'Designação Principal', value: TipoLotacao.Designacao_Principal },
  { name: 'Designação', value: TipoLotacao.Designacao },
  { name: 'Designação Especial', value: TipoLotacao.Designacao_Especial },
];

export const TipoLotacaoEstagioList: IEnumObject[] = [
  { name: 'Não Obrigatório', value: TipoLotacao.Estagio_Nao_Obrigatorio },
  { name: 'Obrigatório', value: TipoLotacao.Estagio_Obrigatorio },
  { name: 'Voluntário', value: TipoLotacao.Estagio_Voluntario },
];

export const TipoLotacaoCompletaList: IEnumObject[] = [
  { name: 'Substituição', value: TipoLotacao.Substituicao },
  { name: 'Acumulação', value: TipoLotacao.Acumulacao },
  { name: 'Titularidade', value: TipoLotacao.Titularidade },
  { name: 'Designação Principal', value: TipoLotacao.Designacao_Principal },
  { name: 'Designação', value: TipoLotacao.Designacao },
  { name: 'Voluntário', value: TipoLotacao.Estagio_Voluntario },
  { name: 'Obrigatório', value: TipoLotacao.Estagio_Obrigatorio },
  { name: 'Não Obrigatório', value: TipoLotacao.Estagio_Nao_Obrigatorio },
  { name: 'Designação Especial', value: TipoLotacao.Designacao_Especial },
];

export const TipoPeriodoDescansoList: IEnumObject[] = [
  { name: 'Férias', value: TipoPeriodoDescanso.Ferias },
  { name: 'Folga Natalícia', value: TipoPeriodoDescanso.FolgaNatalicia },
  {
    name: 'Abono por dia Trabalhado',
    value: TipoPeriodoDescanso.AbonoTrabalhado,
  },
  { name: 'Abono Especial', value: TipoPeriodoDescanso.AbonoEspecial },
  { name: 'Licença Prêmio', value: TipoPeriodoDescanso.LicencaPremio },
  { name: 'Licença Outros Motivos', value: TipoPeriodoDescanso.LicencaOutros },
  // { name: "Afastamento", value: TipoPeriodoDescanso.Afastamento }
];

export const ModuloSistemaList: IEnumObject[] = [
  { name: 'Férias/Lotação', value: ModuloSistema.Ferias },
  { name: 'Movimentações', value: ModuloSistema.Movimentacoes },
];